import React from 'react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface ToggleSwitchProps {
  id?: string;
  name: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  name,
  checked,
  onChange
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  return <label className="relative inline-flex items-center cursor-pointer" data-id="element-647" data-mp="1diajju3p8jic">
      <input id={id} name={name} type="checkbox" checked={checked} onChange={onChange} className="sr-only peer" data-id="element-648" data-mp="18hd0zges1ngb" />
      <div className={`w-11 h-6 rounded-full peer peer-focus:outline-none peer-focus:ring-4 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${dk.isDark ? 'bg-gray-600' : 'bg-gray-200'} ${rt.isReader ? 'peer-checked:bg-indigo-600 peer-focus:ring-indigo-300' : 'peer-checked:bg-purple-600 peer-focus:ring-purple-300'}`} data-id="element-649" data-mp="zgy5jo83mrz3"></div>
    </label>;
};